/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type FineKinneyHazardScoreDefinitionDto = {
    createdBy?: string;
    createdDate?: string;
    lastModifiedBy?: string;
    lastModifiedDate?: string;
    deleted?: boolean;
    id?: string;
    firmId?: string;
    predefinedId?: string;
    source?: FineKinneyHazardScoreDefinitionDto.source;
    label?: string;
    score?: string;
    description?: string;
    deadline?: string;
}

export namespace FineKinneyHazardScoreDefinitionDto {

    export enum source {
        SYSTEM = 'SYSTEM',
        USER_DEFINED = 'USER_DEFINED',
    }


}
